import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BaseUrl, { BaseUrlFE } from "./../BaseUrl";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";

// Slugify function to convert title to URL-friendly slug
const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w\-]+/g, '') // Remove special characters
    .replace(/\-\-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+/, '') // Trim leading hyphens
    .replace(/-+$/, ''); // Trim trailing hyphens
};

// BlogGrid.jsx
export default function BlogGrid() {
  const [blogs, setBlogs] = useState([]);
  const getAllBlogs = async () => {
    const url = BaseUrl() + "api/user/getblogs";
    try {
      const res = await axios.get(url);
      const raw = res.data.blogList;
      setBlogs(Array.isArray(raw) ? raw : []);
    } catch (error) {
      swal("Unable to load blog posts. Please try again.");
    }
  };
  useEffect(() => {
    getAllBlogs();
  }, []);

  const joinUrl = (base, path) => {
    if (!path) return "";
    const b = String(base).replace(/\/$/, "");
    const p = String(path).replace(/^\//, "");
    return `${b}/${p}`;
  };

  const safeText = (v) => {
    if (v == null || v === "") return null;
    const s = String(v).trim();
    if (!s || s === "undefined" || s === "null") return null;
    return s;
  };

  const list = Array.isArray(blogs) ? blogs : [];

  return (
    <div className="mx-auto max-w-7xl px-4 pb-4 pt-2">
      <h2 className="mb-6 text-center text-2xl font-bold text-slate-800 sm:mb-8 sm:text-3xl">
        Latest Blog Posts
      </h2>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
        {list.map((blog) => {
          const excerpt = safeText(blog?.excerpt);
          const imgSrc = joinUrl(BaseUrlFE, blog?.image);
          const imgFallback =
            "data:image/svg+xml," +
            encodeURIComponent(
              `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="448" viewBox="0 0 800 448"><rect fill="#f1f5f9" width="800" height="448"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#94a3b8" font-family="system-ui,sans-serif" font-size="18">No image</text></svg>`,
            );
          return (
            <div
              key={blog?.id}
              className="overflow-hidden rounded-xl bg-white shadow transition duration-300 hover:shadow-lg"
            >
              <Link to={`/details/${slugify(blog?.title)}`}>
                <div className="h-56 w-full overflow-hidden bg-slate-100">
                  <img
                    src={imgSrc || imgFallback}
                    alt={safeText(blog?.alt_tag) || blog?.title || "Blog post"}
                    className="h-full w-full object-cover"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = imgFallback;
                    }}
                  />
                </div>
                <div className="p-5">
                  <h3 className="mb-2 text-xl font-semibold text-slate-900 hover:text-blue-600">
                    {blog?.title}
                  </h3>
                  <span className="inline-block rounded-full bg-blue-100 px-4 py-2 text-sm font-medium text-blue-700 shadow-sm">
                    {safeText(blog?.category?.name) || "General"}
                  </span>
                  <p className="mb-2 mt-2 text-sm text-gray-500">
                    {safeText(blog?.author) || "Admin"} •{" "}
                    {blog?.createdAt
                      ? moment(blog.createdAt).format("dddd D, MMMM YYYY")
                      : ""}
                  </p>
                  {excerpt ? (
                    <p className="text-sm text-gray-700">{excerpt}</p>
                  ) : null}
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}